<template>
  <v-container fluid>
    <v-row class="mb-0">
      <v-col>
        <h1>Задания пациента</h1>
      </v-col>

      <v-col align="right" class="position-relative">
        <v-btn color="primary" @click="openTaskTemplates">Карты наблюдений</v-btn>
      </v-col>
    </v-row>
    <patient-header />

    <tasks-list />
  </v-container>
</template>
<script>
import TasksList from "./components/TasksList";
import Modal from "@/components/Modal";
import TaskTemplatesList from "@/views/pages/tasks/components/TaskTemplatesList.vue";
import PatientHeader from "@/components/PatientHeader";

export default {
  name: "Tasks",

  components: {
    TasksList,
    Modal,
    PatientHeader,
  },

  methods: {
    openTaskTemplates() {
      this.$dialog.show(TaskTemplatesList, { width: 1200 });
    },
  },
};
</script>

<style></style>
